import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';

const SET_PAGE = 'page/SET_PAGE';
export const setPage = createAction(SET_PAGE);

const SET_HIDE_LAYOUT = 'page/SET_HIDE_LAYOUT';
export const setHideLayout = createAction(SET_HIDE_LAYOUT);

const SET_SCROLL_Y = 'page/SET_SCROLL_Y';
export const setScrollY = createAction(SET_SCROLL_Y);

const SET_PAGE_CLASS = 'page/SET_PAGE_CLASS';
export const setPageClass = createAction(SET_PAGE_CLASS);

const SET_PAGE_OPEN_AUTO = 'page/SET_PAGE_OPEN_AUTO';
export const setPageOpenAuto = createAction(SET_PAGE_OPEN_AUTO);

const SET_PAGE_CLOSE_AUTO = 'page/SET_PAGE_CLOSE_AUTO';
export const setPageCloseAuto = createAction(SET_PAGE_CLOSE_AUTO);

const SET_SCROLL_TARGET_ID = 'page/SET_SCROLL_TARGET_ID';
export const setScrollTargetId = createAction(SET_SCROLL_TARGET_ID);

const initialState = {
	pageType: '',
	hideLayout: false,
	scrollY: 0,
	pageClass: '',
	scrollTargetId: '',
};

export default handleActions(
	{
		[SET_PAGE]: (state, action) =>
			produce(state, (draft) => {
				draft.pageType = action.payload;
			}),

		[SET_HIDE_LAYOUT]: (state, action) =>
			produce(state, (draft) => {
				draft.hideLayout = action.payload;
			}),

		[SET_SCROLL_Y]: (state, action) =>
			produce(state, (draft) => {
				draft.scrollY = action.payload;
			}),

		[SET_PAGE_CLASS]: (state, action) =>
			produce(state, (draft) => {
				draft.pageClass = action.payload;
			}),

		[SET_PAGE_OPEN_AUTO]: (state, action) =>
			produce(state, (draft) => {
				draft.pageType = action.payload.pageType;
				draft.pageClass = action.payload.pageClass;
				draft.scrollY = action.payload.scrollY;
			}),

		[SET_PAGE_CLOSE_AUTO]: (state, action) =>
			produce(state, (draft) => {
				draft.pageClass = action.payload.pageClass;
				draft.hideLayout = action.payload.hideLayout;
			}),

		[SET_SCROLL_TARGET_ID]: (state, action) =>
			produce(state, (draft) => {
				draft.scrollTargetId = action.payload;
			}),
	},
	initialState,
);
